// src/components/Form.js

import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { Col, Button, Form, Modal } from "react-bootstrap";
import emailjs from "emailjs-com";
import "../assets/css/form.css"; // Aggiungiamo un file CSS per personalizzare la modale
// src/components/Form.js

const FormComponent = ({ curr_lang, t, ...props }) => {
  const [validated, setValidated] = useState(false);
  const [showThanks, setShowThanks] = useState(false);
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const formRef = useRef(null);
  const debug = process.env.REACT_APP_FORM_DEBUG === "true";

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formEl = formRef.current;

    // attiva validazione
    setValidated(true);
    if (formEl.checkValidity && formEl.checkValidity() === false) {
      event.stopPropagation();
      return;
    }

    // log dei dati inviati
    const formData = new FormData(formEl);
    for (const [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }

    if (!debug) {
      try {
        const result = await emailjs.sendForm(
          "service_corenno",
          "template_corenno",
          formEl,
          "1T_a_CXUZVmFTFxPq"
        );
        console.log("Email inviata:", result.text);
      } catch (error) {
        console.error("Errore nell'invio dell'email:", error);
      }
    } else {
      console.log("⚙️ Debug mode: invio email saltato");
    }

    // mostra il popup di ringraziamento
    setShowThanks(true);
  };

  // Funzione per resettare il form
  const resetForm = () => {
    if (formRef.current) {
      formRef.current.reset();
      setValidated(false);
      setPrivacyChecked(false);
    }
    setShowThanks(false);
  };

  // Funzione per gestire il cambio di stato del checkbox privacy
  const handlePrivacyChange = (e) => {
    setPrivacyChecked(e.target.checked);
  };

  return (
    <>
      <Form
        ref={formRef}
        noValidate
        validated={validated}
        className="contact-form"
        onSubmit={handleSubmit}
      >
        <div className="row">
          <Form.Group as={Col} md="6" controlId="validationCustom01">
            <Form.Control
              required
              type="text"
              placeholder={t("components.form.fields.nome.placeholder")}
              name={t("components.form.fields.nome.name")}
            />
            <Form.Control.Feedback type="invalid">
              {t("components.form.required")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="6" controlId="validationCustom02">
            <Form.Control
              required
              type="text"
              placeholder={t("components.form.fields.cognome.placeholder")}
              name={t("components.form.fields.cognome.name")}
            />
            <Form.Control.Feedback type="invalid">
              {t("components.form.required")}
            </Form.Control.Feedback>
          </Form.Group>
        </div>

        <div className="row mt-3">
          <Form.Group as={Col} md="6" controlId="validationCustom03">
            <Form.Control
              required
              type="email"
              placeholder={t("components.form.fields.email.placeholder")}
              name={t("components.form.fields.email.name")}
            />
            <Form.Control.Feedback type="invalid">
              {t("components.form.required")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="6" controlId="validationCustom04">
            <Form.Control
              type="text"
              placeholder={t("components.form.fields.telefono.placeholder")}
              name={t("components.form.fields.telefono.name")}
            />
          </Form.Group>
        </div>

        <div className="row mt-3 mb-3">
          <Form.Group as={Col} md="12" controlId="validationCustom05">
            <Form.Control
              required
              as="textarea"
              rows={3}
              placeholder={t("components.form.fields.messaggio.placeholder")}
              name={t("components.form.fields.messaggio.name")}
            />
            <Form.Control.Feedback type="invalid">
              {t("components.form.required")}
            </Form.Control.Feedback>
          </Form.Group>
        </div>

        <Form.Group controlId="validationPrivacy" className="privacy-group">
          <div className="privacy-check-container">
            <Form.Check
              required
              inline
              name="privacyAccepted"
              type="checkbox"
              onChange={handlePrivacyChange}
              checked={privacyChecked}
            />
            <span>
              {t("components.form.iAccept")}{" "}
              <a href={`/${curr_lang}/privacy-policy`}>
                {t("components.form.privacyPolicy")}
              </a>
            </span>
          </div>

          {validated && !privacyChecked && (
            <div className="invalid-feedback d-block mt-1">
              {t("components.form.required")}
            </div>
          )}
        </Form.Group>

        <Button
          type="submit"
          className="btn mt-3 btn-primary transparent text-medium btn-lg"
        >
          {t("components.form.cta")}
        </Button>
      </Form>

      {/* Thank-you Modal */}
      <Modal
        show={showThanks}
        onHide={resetForm}
        centered
        className="custom-modal"
      >
        <Modal.Header>
          <Modal.Title>{t("components.form.thankYouTitle")}</Modal.Title>
          <button className="custom-close-button" onClick={resetForm}>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.2627 13.5807L8.8007 10.1187L5.15203 13.7674L3.92167 12.537L7.57034 8.88837L4.12531 5.44335L5.27083 4.29784L8.71585 7.74286L12.3391 4.11965L13.5694 5.35001L9.94622 8.97323L13.4082 12.4352L12.2627 13.5807Z"
                fill="#353535"
              />
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body>
          {t("components.form.thankYouMessage") ||
            "Your email was sent correctly."}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={resetForm}>
            {t("components.form.closeThankYouMessage")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => ({
  ...state,
});

export default connect(mapStateToProps)(FormComponent);
